import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from './user.service';

@Injectable({
    providedIn: 'root'
})
export class RouterService {
    private router = inject(Router);
    private userService = inject(UserService);

    getDefaultRouteForRole(): string {
        const claims = this.userService.userClaims() as { admin?: boolean; manager?: boolean; employee?: boolean; };
        if (claims.admin || claims.manager) return "dashboard";
        if (claims.employee) return "dashboard";
        return "auth/login";
    }

    navigateToDefaultRoute(): Promise<boolean> {
        const route = this.getDefaultRouteForRole();
        return this.router.navigate([route]);
    }

    /**
     * Startseite öffnen und neu laden (Rollen-Ansicht, #1264): Seiten, die ihre
     * Daten nur beim Öffnen rollenabhängig laden, sollen nicht auf dem alten
     * Rollenstand stehen bleiben.
     */
    reloadOnDefaultRoute(): void {
        void this.navigateToDefaultRoute().then(() => window.location.reload());
    }
}
